import { DatabaseColumn } from 'interfaces/report-configuration.interface';
import { Checkbox } from 'shared-components';
import { cn } from 'utils/global';

interface TableItemsListProps {
  items: DatabaseColumn[] | any[];
  isSelected: (item: DatabaseColumn) => boolean;
  onToggleColumn: (item: DatabaseColumn) => void;
}

function TableItemsList({ items, isSelected, onToggleColumn }: TableItemsListProps) {
  return (
    <ul>
      {items.map((item) => {
        const selected = isSelected(item);
        return (
          <li
            key={item.name}
            className={cn(
              'flex items-center p-2 cursor-pointer hover:bg-neutral-50 dark:hover:bg-neutral-900 rounded',
              {
                '!bg-primary-50': isSelected(item),
              }
            )}
          >
            <Checkbox
              label={item.name}
              labelClassName={cn('text-neutral-900 dark:text-neutral-100', { '!text-primary-500': isSelected(item) })}
              checked={selected}
              onChange={() => onToggleColumn(item)}
              disabled={false}
              dataCy={`checkbox-${item.name}`}
            />
          </li>
        );
      })}
    </ul>
  );
}

export default TableItemsList;
